/**
 * Get authorization headers for API requests
 * @returns {Object} Headers object with Authorization token if available
 */
export const getAuthHeaders = () => {
  const token = localStorage.getItem('access_token');
  
  if (token) {
    return {
      'Authorization': `Bearer ${token}`
    };
  }
  
  return {};
};

/**
 * Clear authentication data
 */
export const clearAuth = () => {
  localStorage.removeItem('access_token');
};

/**
 * Check if user is authenticated
 * @returns {boolean} True if token exists
 */
export const isAuthenticated = () => {
  return !!localStorage.getItem('access_token');
};
